export enum AssetTypes {
    SMOOSH = 'smoosh',
    MODEL = 'model',
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large'
}
